import React from "react";
import gif from "../assets/gif/animation_500_kc4ogugy.gif";
var LoadingIndicator = (props) => {
   let { rootClass = false } = props;
   return (
      <div className={rootClass ? rootClass : "loading"}>
         <img alt="loading" src={gif} />
      </div>
   );
};
export default LoadingIndicator;
